import moment from "moment";

//--> 이 아이디들만 모든 날짜를 볼 수 있다. 나머지(강사 등)는 오늘부터 1주일치만.
const UNLIMITED_USER_IDS = ["admin", "system"];

//--> 오늘 포함 며칠치까지 보이게 할지
const VIEWABLE_DAYS = 7;

export const isUnlimitedScheduleUser = (user: any) => {
  if (!user || !user.userId) return false;
  return UNLIMITED_USER_IDS.indexOf(`${user.userId}`.toLowerCase()) >= 0;
};

//--> 볼 수 있는 기간. [오늘, 오늘+6] (오늘 포함 7일)
export const getViewableScheduleRange = () => {
  const from = moment().startOf("day");
  const to = moment().startOf("day").add(VIEWABLE_DAYS - 1, "days");
  return { from, to };
};

//--> 그 날짜를 볼 수 있는지. 지난 수업과 1주일 뒤는 막는다.
export const canViewScheduleDate = (user: any, date: any) => {
  if (isUnlimitedScheduleUser(user)) return true;
  if (!date) return false;

  const target = moment(date, "YYYY-MM-DD").startOf("day");
  if (!target.isValid()) return false;

  const { from, to } = getViewableScheduleRange();
  return !target.isBefore(from) && !target.isAfter(to);
};
